<template>
  <a
    v-bind="props.action"
    href="#"
    class="relative flex justify-between items-center gap-2"
    @click.prevent="handleNotificationClick(item)"
  >
    <div class="flex flex-col justify-center gap-0.5">
      <div class="flex items-center gap-1.5">
        <i class="pi pi-megaphone"></i>
        <span class="text-sm font-semibold text-gray-800 dark:text-gray-200">Company Announcement</span>
      </div>
      <span class="text-xs text-gray-500">
        <span class="font-medium text-gray-900 dark:text-white">{{ item.announcement?.title ?? 'New announcement' }}</span>
      </span>
    </div>
    <span class="text-xs text-gray-500">{{ formatNotificationDate(item.createdAt) }}</span>
    <Badge v-if="!item.readAt" severity="warn" class="absolute top-1.5 right-2" />
  </a>
</template>

<script setup>
/* global defineProps */
import { Badge } from 'primevue'
import { formatNotificationDate } from '@/utils/helpers'

defineProps(['item', 'props', 'handleNotificationClick'])
</script>
